import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-toast{
  display:flex;align-items:center;gap:12px;font-family:var(--font-sans);
  background:var(--surface-card);border:1px solid var(--border-subtle);
  border-radius:var(--radius-md);box-shadow:var(--shadow-lg);
  padding:12px 14px;min-width:280px;max-width:420px;
  animation:js-toast-in var(--dur-base) var(--ease-out);
}
@keyframes js-toast-in{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}
.js-toast__icon{width:30px;height:30px;border-radius:var(--radius-sm);display:flex;align-items:center;justify-content:center;flex:none;font-weight:700}
.js-toast--success .js-toast__icon{background:var(--success-bg);color:var(--success-fg)}
.js-toast--danger .js-toast__icon{background:var(--danger-bg);color:var(--danger-fg)}
.js-toast--info .js-toast__icon{background:var(--info-bg);color:var(--info-fg)}
.js-toast--warning .js-toast__icon{background:var(--warning-bg);color:var(--warning-fg)}
.js-toast__body{flex:1;min-width:0}
.js-toast__title{font-size:var(--text-sm);font-weight:var(--weight-bold);color:var(--text-strong)}
.js-toast__msg{font-size:var(--text-xs);color:var(--text-muted);margin-top:1px}
.js-toast__close{border:none;background:transparent;color:var(--text-subtle);cursor:pointer;font-size:16px;line-height:1;padding:4px;border-radius:6px}
.js-toast__close:hover{background:var(--neutral-100);color:var(--text-strong)}
`;

const GLYPH: Record<string, string> = { success: "✓", danger: "✕", info: "i", warning: "!" };

export type ToastTone = "success" | "danger" | "info" | "warning";

export interface ToastProps extends HTMLAttributes<HTMLDivElement> {
  tone?: ToastTone;
  title?: ReactNode;
  onClose?: () => void;
}

export function Toast({ tone = "success", title, children, onClose, className = "", ...rest }: ToastProps) {
  injectCss("js-toast-css", CSS);
  return (
    <div className={["js-toast", `js-toast--${tone}`, className].filter(Boolean).join(" ")} role="status" {...rest}>
      <span className="js-toast__icon">{GLYPH[tone]}</span>
      <div className="js-toast__body">
        {title && <div className="js-toast__title">{title}</div>}
        {children && <div className="js-toast__msg">{children}</div>}
      </div>
      {onClose && (
        <button type="button" className="js-toast__close" aria-label="关闭" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
}
